import { notify } from 'mycorems-app-shared';
import { Error } from '@/types';
import { refreshAccessToken } from '@/authentication';
import handler from '.';

const excludeCodes = ['REFRESH_TOKEN.INVALID'];

handler.onError((error: Error) => {
  if (excludeCodes.includes(error.code)) return;
  const message = error.message || `The following error occurred: ${error.code}`;
  notify.failure(message);
});

handler.onAuthError(refreshAccessToken);
